import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { Typography } from 'shared/ui/Typography';

import styled from '@emotion/styled';

export const RootStyled = styled(Box)({
  position: 'sticky',
  zIndex: 4,
  background: 'linear-gradient(rgba(249, 244, 239, 1) 90%,rgba(249, 244, 239, .9) 95%,  rgba(249, 244, 239, 0) 100% )',
});

export const HeaderStyled = styled(Box)`
  width: 100%;
  display: flex;
  position: fixed;
  padding: ${theme.space[4]};
  justify-content: space-between;
  align-items: center;
  margin-right: ${theme.space[6]};
  background-color: ${theme.colors.yellow800};
  z-index: 4;
  border-bottom: 2px solid #000;
`;

export const TittleStyled = styled(Typography)({
  fontSize: theme.fontSizes[27],
  fontWeight: theme.fontWeights.extraBold,
  color: theme.colors.black,
  display: 'block',
});

export const MobileSearchInputStyled = styled('input')({
  padding: theme.space[2],
  width: '100%',
  marginRight: theme.space[4],
  outline: 'none',
  border: theme.borders.md,
});
